import apiClient from './apiClient';

export interface ProfessionalArticle {
  title: string;
  content: string;
  source: string;
  source_url: string;
  article_url: string;
  published_date?: string;
  category: string;
  topics?: string[];
  image_url?: string;
}

export interface ExtractedTopics {
  skills: string[];
  interests: string[];
  industries: string[];
  roles: string[];
  experience_level: string;
}

export interface ProfessionalFeedsResponse {
  articles: ProfessionalArticle[];
  topics: ExtractedTopics;
  totalArticles: number;
  categories: string[];
  generatedAt: string;
}

class ProfessionalFeedsService {
  /**
   * Get personalized professional articles
   */
  async getProfessionalArticles(options?: {
    limit?: number;
    useResume?: boolean;
  }): Promise<ProfessionalFeedsResponse> {
    const params = new URLSearchParams();
    if (options?.limit) {
      params.append('limit', options.limit.toString());
    }
    if (options?.useResume !== undefined) {
      params.append('useResume', options.useResume.toString());
    }

    const response = await apiClient.get(`/feed/professional?${params.toString()}`);
    return response as ProfessionalFeedsResponse;
  }

  /**
   * Get available categories
   */
  async getCategories(): Promise<string[]> {
    const response = await apiClient.get('/feed/professional/categories');
    return response as string[];
  }

  /**
   * Refresh topics from latest resume
   */
  async refreshTopics(): Promise<{
    topics: ExtractedTopics;
    source: 'resume' | 'profile';
  }> {
    const response = await apiClient.post('/feed/professional/refresh-topics');
    return response as {
      topics: ExtractedTopics;
      source: 'resume' | 'profile';
    };
  }
}

const professionalFeedsService = new ProfessionalFeedsService();
export default professionalFeedsService;